<template>
  <f7-page
    class="page-content-log"
  >
    <Selection />
  </f7-page>
</template>

<script>

import { mapActions } from 'vuex';
import Selection from '../../components/selection/index.vue';

export default {
  name: 'SelectionPage',
  components: {
    Selection,
  },
  beforeMount() {
    this.setShowLeftPanel(false);
  },
  methods: {
    ...mapActions('authentication', ['setShowLeftPanel']),
  },
};
</script>

<style>

</style>
